import { defineComponent as _defineComponent } from 'vue';
import { ErrorMessage } from "vee-validate";
import { toValue } from "vue";
import { cn } from 'Components/primitives/utils';
import { useFormField } from "./useFormField";
export default /*@__PURE__*/ _defineComponent({
    __name: 'FormMessage',
    props: {
        class: { type: [Boolean, null, String, Object, Array], required: false, skipCheck: true }
    },
    setup(__props, { expose: __expose }) {
        __expose();
        const props = __props;
        const { name, formMessageId } = useFormField();
        const __returned__ = { props, name, formMessageId, get ErrorMessage() { return ErrorMessage; }, toValue, get cn() { return cn; } };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
